import React from 'react';
import type { MessageBoardPostUrgency } from '../../../services/messageBoardService';

export interface MessageBoardPostProgressProps {
  readCount: number;
  recipientCount: number;
  urgency?: MessageBoardPostUrgency;
}

const MessageBoardPostProgress: React.FC<MessageBoardPostProgressProps> = ({
  readCount,
  recipientCount,
  urgency = 'NORMAL',
}) => {
  const safeRead = Math.max(0, readCount);
  const safeRecipients = Math.max(0, recipientCount);
  const pct = safeRecipients === 0 ? 0 : Math.min(100, (safeRead / safeRecipients) * 100);
  const fillClass = urgency === 'URGENT' ? 'tw-bg-accent' : 'tw-bg-primary';

  return (
    <div className="tw-mt-2 tw-flex tw-items-center tw-gap-2">
      <div
        className="tw-h-1 tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-rounded-full tw-bg-surface-hover"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeRecipients}
        aria-valuenow={safeRead}
        aria-label={`${safeRead} of ${safeRecipients} seen`}
      >
        <div
          data-testid="message-board-progress-fill"
          className={`tw-h-full tw-rounded-full ${fillClass}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="tw-mb-0 tw-shrink-0 tw-text-xs tw-tabular-nums tw-text-content-muted">
        {safeRead}/{safeRecipients} seen
      </p>
    </div>
  );
};

export default MessageBoardPostProgress;
